/**
 * The glance half of showing a version: one muted line an operator can read out over the phone,
 * and the way into the full detail.
 *
 * Deliberately carries no colour of its own. It sits on admin-web's ink-green rail, on room-web's
 * charcoal one and at the foot of player-web's on-air ground — three different grounds, so a token
 * that looked right on any one of them would be wrong on the other two. The caller supplies the
 * colour through `className`; this owns the size, the tracking and the tabular figures, which are
 * the parts that should not be re-decided per app.
 *
 * The commit is hidden below `sm`. On a phone the version alone is what fits, and it is also the
 * part somebody is being asked for.
 */
export function VersionBadge({
  version,
  commit,
  onClick,
  className,
}: {
  version: string;
  /** Already shortened for display — see `shortCommit` in @brush/build-info. */
  commit?: string | null;
  /** Opens the About detail. */
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      // Named rather than described: "About" alone would be read out with no clue that it
      // carries the version, which is the thing support asks for.
      aria-label={`Version ${version}${commit ? `, build ${commit}` : ''}. Open build details`}
      className={`num text-[10.5px] tracking-[0.06em] underline-offset-2 transition hover:underline ${className ?? ''}`}
    >
      v{version}
      {commit ? <span className="hidden sm:inline"> · {commit}</span> : null}
    </button>
  );
}
